import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b84f0c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "quick-search-dropdown"
}
const _hoisted_2 = { class: "activity-label" }
const _hoisted_3 = { class: "skeleton-content" }
const _hoisted_4 = { class: "results-header" }
const _hoisted_5 = { class: "results-count" }
const _hoisted_6 = { class: "result-number" }
const _hoisted_7 = { class: "info-item" }
const _hoisted_8 = { class: "info-text" }
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = { class: "info-text" }
const _hoisted_11 = { class: "info-item" }
const _hoisted_12 = { class: "info-text" }
const _hoisted_13 = { class: "info-item" }
const _hoisted_14 = { class: "info-text" }
const _hoisted_15 = { class: "no-results-title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-results-hint" }, "Essayez N° Commande, Chassis, Immatriculation...", -1))
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"status-legend\" data-v-1b84f0c8><span class=\"legend-title\" data-v-1b84f0c8>STATUTS:</span><div class=\"legend-item\" data-v-1b84f0c8><div class=\"legend-dot bg-positive\" data-v-1b84f0c8></div><span data-v-1b84f0c8>Validé</span></div><div class=\"legend-item\" data-v-1b84f0c8><div class=\"legend-dot bg-blue\" data-v-1b84f0c8></div><span data-v-1b84f0c8>Confirmé</span></div><div class=\"legend-item\" data-v-1b84f0c8><div class=\"legend-dot bg-orange\" data-v-1b84f0c8></div><span data-v-1b84f0c8>En cours</span></div><div class=\"legend-item\" data-v-1b84f0c8><div class=\"legend-dot bg-grey\" data-v-1b84f0c8></div><span data-v-1b84f0c8>Brouillon</span></div></div><div class=\"keyboard-hints\" data-v-1b84f0c8><div class=\"hint-item\" data-v-1b84f0c8><kbd data-v-1b84f0c8>↑↓</kbd> Naviguer </div><div class=\"hint-item\" data-v-1b84f0c8><kbd data-v-1b84f0c8>Enter</kbd> Ouvrir </div><div class=\"hint-item\" data-v-1b84f0c8><kbd data-v-1b84f0c8>Esc</kbd> Fermer </div></div>", 2)
const _hoisted_19 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["quick-search-wrapper", { 'is-open': _ctx.isOpen, 'is-always-open': _ctx.alwaysOpen }])
  }, [
    (!_ctx.alwaysOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["search-icon-btn", { 'icon-active': _ctx.isOpen }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSearch && _ctx.toggleSearch(...args)))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["icon-circle", { 'icon-small': _ctx.isOpen }]),
            style: {}
          }, [
            _createVNode(_component_q_icon, {
              name: _ctx.isOpen ? 'close' : 'search',
              size: "md",
              color: _ctx.isOpen ? 'white' : 'grey-8',
              class: "icon-flip",
              style: _normalizeStyle(_ctx.isOpen ? 'font-size: 20px;':'font-size: 32px;')
            }, null, 8, ["name", "color", "style"])
          ], 2),
          _createVNode(_component_q_tooltip, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isOpen ? 'Fermer' : _ctx.$t('main.quickSearch.tooltip')), 1)
            ]),
            _: 1
          })
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade-scale" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createBlock(_component_q_input, {
              key: 0,
              ref: "searchInput",
              modelValue: _ctx.searchQuery,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
                _ctx.onSearchInput
              ],
              dense: "",
              outlined: "",
              placeholder: _ctx.$t('main.quickSearch.placeholder'),
              class: "search-input-center",
              onInput: _ctx.onSearchInput,
              onFocus: _ctx.onFocus,
              onBlur: _ctx.onBlur,
              onKeydown: [
                _withKeys(_withModifiers(_ctx.handleEnter, ["prevent"]), ["enter"]),
                _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.navigateResults('down')), ["prevent"]), ["down"])),
                _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.navigateResults('up')), ["prevent"]), ["up"])),
                _withKeys(_ctx.closeSearch, ["escape"])
              ],
              "bg-color": "white",
              style: {"margin-bottom":"5px"}
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: _ctx.detectedTypeIcon,
                  size: "sm",
                  color: _ctx.searchQuery ? 'primary' : 'grey-6'
                }, {
                  default: _withCtx(() => [
                    (_ctx.searchQuery)
                      ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.detectedTypeLabel), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["name", "color"])
              ]),
              append: _withCtx(() => [
                (_ctx.searchQuery)
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 0,
                      name: "close",
                      class: "cursor-pointer",
                      size: "xs",
                      onClick: _ctx.clearSearch
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                      key: 1,
                      size: "18px",
                      color: "primary"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "onUpdate:modelValue", "onInput", "onFocus", "onBlur", "onKeydown"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.isOpen && (_ctx.isFocused || _ctx.showResults))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "activity-chips-wrapper",
            onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('main.dossier.filtreMenu.activity')) + ":", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityOptions, (activity) => {
              return (_openBlock(), _createBlock(_component_q_chip, {
                key: activity.value,
                clickable: "",
                color: _ctx.selectedActivity === activity.value ? (activity.value ? 'blue' : 'positive') : 'grey-3',
                "text-color": _ctx.selectedActivity === activity.value ? 'white' : 'grey-8',
                onClick: ($event: any) => (_ctx.selectActivity(activity.value)),
                class: "activity-chip",
                icon: "none"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(activity.label), 1)
                ]),
                _: 2
              }, 1032, ["color", "text-color", "onClick"]))
            }), 128))
          ], 32),
          (_ctx.isLoading && _ctx.searchQuery)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "skeleton-loading",
                onMousedown: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                  return _createElementVNode("div", {
                    class: "skeleton-item",
                    key: n
                  }, [
                    _createVNode(_component_q_skeleton, {
                      type: "circle",
                      size: "28px"
                    }),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_q_skeleton, {
                        type: "text",
                        width: "40%"
                      }),
                      _createVNode(_component_q_skeleton, {
                        type: "text",
                        width: "70%",
                        class: "q-mt-xs"
                      })
                    ])
                  ])
                }), 64))
              ], 32))
            : _createCommentVNode("", true),
          (_ctx.showResults && _ctx.searchResults.length > 0 && !_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "search-results-dropdown",
                onMousedown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.searchResults.length) + " " + _toDisplayString(_ctx.$t('main.quickSearch.results')), 1)
                ]),
                _createVNode(_component_q_list, { class: "results-list" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (result, index) => {
                      return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: result.resourceUid,
                        clickable: "",
                        class: _normalizeClass({ 'active-result': index === _ctx.selectedResultIndex }),
                        onClick: ($event: any) => (_ctx.selectResult(result)),
                        onMouseenter: ($event: any) => (_ctx.selectedResultIndex = index)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { avatar: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_avatar, {
                                color: _ctx.getStatusColor(result.statusCode),
                                "text-color": "white",
                                size: "28px"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "receipt_long",
                                    size: "xs"
                                  })
                                ]),
                                _: 2
                              }, 1032, ["color"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, { class: "result-title-row" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("strong", _hoisted_6, _toDisplayString(result.externalReference), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_q_item_label, {
                                caption: "",
                                class: "result-info-row q-mt-xs"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_q_icon, {
                                      name: "precision_manufacturing",
                                      size: "14px",
                                      color: "blue-grey-7"
                                    }),
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(result.manufacturingNumber || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_9, [
                                    _createVNode(_component_q_icon, {
                                      name: "directions_car",
                                      size: "14px",
                                      color: "blue-grey-7"
                                    }),
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(result.chassisReference || '-'), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_q_item_label, {
                                caption: "",
                                class: "result-info-row q-mt-xs"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_component_q_icon, {
                                      name: "pin_drop",
                                      size: "14px",
                                      color: "blue-grey-7"
                                    }),
                                    _createElementVNode("span", _hoisted_12, _toDisplayString(result.registrationNumber || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_component_q_icon, {
                                      name: "person_outline",
                                      size: "14px",
                                      color: "blue-grey-7"
                                    }),
                                    _createElementVNode("span", _hoisted_14, _toDisplayString(result.clientName || '-'), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_q_item_section, { side: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                name: "arrow_forward",
                                color: "primary"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["class", "onClick", "onMouseenter"])), [
                        [_directive_ripple]
                      ])
                    }), 128))
                  ]),
                  _: 1
                })
              ], 32))
            : _createCommentVNode("", true),
          (_ctx.showResults && _ctx.searchQuery && _ctx.searchResults.length === 0 && !_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "no-results-modern",
                onMousedown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _createVNode(_component_q_icon, {
                  name: "search_off",
                  size: "48px",
                  color: "grey-4"
                }),
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('main.quickSearch.noResults')), 1),
                _hoisted_16
              ], 32))
            : _createCommentVNode("", true),
          (_ctx.isFocused && !_ctx.searchQuery && !_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "hints-footer",
                onMousedown: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
              }, _hoisted_19, 32))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}